import Component from "@tunnel-components/@pages/supervision/display/home/component";
import * as React from "react";
import { connect } from "react-redux";
import * as i18next from "i18next"; // traduction
import * as Lodash from "lodash";
import {
  ParametersDisplayLoadedActionCreator,
  DisplayParamVideoLoadedActionCreator,
  DisplayParamVideoActionCreator,
  ParametersDisplayUpdatedActionCreator,
} from "@tunnel-store/index";

/**
 * @class Container : Composant à état
 * @description : composant “complexe” recevant des props et possédant
 * un état interne pour générer son rendu.
 * @extends { React.PureComponent }
 * @implements
 * @method
 * @name onChangeDisplayHome
 * @name onChange
 * @name onDisabledDesc
 * @name onSubmit
 * @name
 * @name componentDidUpdate
 * @name componentWillReceiveProps
 * @name render
 * @infos "https://reactjs.org"
 */
class Container extends React.PureComponent<any, any> {
  //  faire cette action toute les 3000 millisecondes
  public debounceSubmit = Lodash.debounce((event: any) => {
    this.props
      .ParametersDisplayUpdatedActionCreator(
        this.state.incidentDuration,
        this.state.radio[0]
      )
      .then(() =>
        this.setState((state: any): any => ({
          btnloading: false,
          displayaction: true,
          extractionVideoBoolean: false,
        }))
      );
  }, 3000);

  /**
   * @constructor
   * @description :
   * Le Constructor est invoqué en premier.
   * Il reçoit en argument toutes les props initiales du composant
   * Le Constructor est aussi utilisé pour Binder les events Handler à l’instance.
   * @param { objet <any> } props
   */
  public constructor(props: any) {
    /**
     * @function
     * @description : Utilisé afin d'appeler ou d'accéder
     * à des fonctions définies sur l'objet parent.
     */
    super(props);
    /**
     * @namespace
     * @description : possède des informations sur le composant
     * @property { object }       state
     * @property { boolean }      state.errorserver
     * @property { boolean }      state.loading
     * ......
     */
    this.state = {
      btnloading: false,
      displayArray: [
        i18next.t(
          "afficher tous les incidents non qualifies (en cours ou termines)"
        ),
        i18next.t(
          "ne pas afficher les incidents non qualifies s’ils sont termines"
        ),
      ],
      displayaction: false,
      errorserver: false,
      incidentDuration: "",
      isNaN: false,
      loading: false,
      preSequence: 0,
      postSequence: 0,
      durreMaxExtraction: 0,
      radio: [],
      rulesVideoObject: [],
      seaRadio: [false, false, false, false, false],
      video: [],
    };
    /**
     * @description : Empêcher l'exécution des méthodes à chaque initialisation
     * des composants ; "seulement quand un event est exécuté"
     */
    this.onChange = this.onChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeDisplayHome = this.onChangeDisplayHome.bind(this);
    this.onSubmitEVideo = this.onSubmitEVideo.bind(this);
    this.onSubmitSea = this.onSubmitSea.bind(this);
    this.onChangeDisplaySea = this.onChangeDisplaySea.bind(this);
    this.onChangeVideoRules = this.onChangeVideoRules.bind(this);
  }
  /**
   * Manipulation des data vers le server
   * @public
   * @method onChangeVideoRules
   * @param { any } event
   * @param { number } index
   * @param { number } identifiant
   * @infos "https://reactjs.org"
   */
  public onChangeVideoRules = (index: number, identifiant: number) => (
    event: any
  ) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** vérification de l'existence de l'élement  */
    }
    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0
    ) {
      /**
       * @constant
       * @name rulesVideoObject
       * @type any[]
       */
      const rulesVideoObject: any[] = [];
      {
        /** boucle */
      }
      for (let i = 0; i < Math.ceil(this.state.rulesVideoObject.length); i++) {
        rulesVideoObject.push(this.state.rulesVideoObject[i]);
      }
      rulesVideoObject[index].value = Number(event.target.value);
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ rulesVideoObject }));
      this.setState((state: any): any => ({
        displayaction: false,
        extractionVideoBoolean: false,
      }));
    } else {
      this.setState((state: any): any => ({ isNaN: true }));
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name
   * @description : il est appelée. Une fois le rendu fait,
   * C’est le moment idéal pour aller chercher
   * les références directes des éléments du DOM
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentDidMount() {
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ loading: true }));

    this.props.DisplayParamVideoLoadedActionCreator();

    this.props
      .ParametersDisplayLoadedActionCreator()
      .then(() => this.onUpdatevalue(this.props.data))
      .then(() => this.setState((state: any): any => ({ loading: false })))
      .then(() => {
        if (!Lodash.isUndefined(this.props.error)) {
          this.setState((state: any): any => ({ errorserver: true }));
        }
      });
  }
  /**
   * @description " MAJ de l'état des composant à l'initialisation"
   * @method
   * @name onUpdatevalue
   * @param { any }  Elem
   * @return { void }
   */
  public onUpdatevalue = (Elem: any): void => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Elem) {
      /**
       * @constant
       * @name radio
       * @type boolean[]
       */
      const radio: boolean[] = [];
      {
        /** Comparaison */
      }
      if (Elem[0].name === "DISPLAY_QUALIFIED_DURATION_EXCEEDED") {
        {
          /** Comparaison */
        }
        if (Elem[1].value === "false") {
          radio[0] = false;
          radio[1] = true;
        } else {
          radio[0] = true;
          radio[1] = false;
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          incidentDuration: Elem[0].value,
          radio,
        }));
        {
          /** Comparaison */
        }
      } else if (Elem[1].name === "DISPLAY_QUALIFIED_DURATION_EXCEEDED") {
        {
          /** Comparaison */
        }
        if (Elem[0].value === "false") {
          radio[0] = false;
          radio[1] = true;
        } else {
          radio[0] = true;
          radio[1] = false;
        }
        {
          /** Empêcher la mutation du state */
        }
        this.setState((state: any): any => ({
          incidentDuration: Elem[1].value,
          radio,
        }));
      }
    }
  };
  /**
   * @method
   * @name onSortDynamic
   * @param { any } Elem
   * @return { any }
   * @infos "https://reactjs.org"
   */
  public onSortDynamic = (Elem: any): any => {
    {
      /** Vérification de l'existence d'une variable */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.id > b.id ? 1 : b.id > a.id ? -1 : 0
      );
    }
  };
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillReceiveProps
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } nextProps
   * @infos "https://reactjs.org"
   */
  public componentWillReceiveProps(nextProps: any) {
    {
      /** Comparaison */
    }
    if (nextProps.error !== this.props.error) {
      if (!Lodash.isUndefined(nextProps.error)) {
        this.setState((state: any): any => ({ errorserver: true }));
      }
    } else if (nextProps.data !== this.props.data) {
      this.onUpdatevalue(nextProps.data);
    } else if (nextProps.videoInfosData !== this.props.videoInfosData) {
      {
        /** Empêcher la mutation du state */
      }

      /**
       * @constant
       * @name rulesVideoObject
       * @type any[]
       */
      const rulesVideoObject: any[] = [];
      /**
       * @constant
       * @name videoInfos
       * @type any[]
       */
      const videoInfos: any[] = this.onSortDynamic(nextProps.videoInfosData);

      for (let i = 0; i < Math.ceil(videoInfos.length); i++) {
        rulesVideoObject.push({
          id: videoInfos[i].id,
          value: videoInfos[i].value,
        });
      }
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({
        video: videoInfos,
        rulesVideoObject,
        extractionVideoBoolean: false,
      }));
    }
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentWillUnmount
   * @description : il est appelée.
   * Avant que le composant soit supprimé du DOM.
   * Cette méthode peut être utile lorsque vous devez effectuer
   * des opérations de nettoyage.
   * @param { void }
   * @infos "https://reactjs.org"
   */
  public componentWillUnmount() {
    // Stopper l'action une fois le component détruit
    this.debounceSubmit.cancel();
    {
      /** Empêcher la mutation du state */
    }

    this.setState((state: any): any => ({
      displayaction: false,
      errorserver: false,
      isNaN: false,
      loading: false,
    }));
  }
  /**
   * Cycle de vie d'un composant react
   * @method
   * @name componentDidUpdate
   * @description : La méthode  est appelée uniquement lorsque les props
   * ont changé et lorsqu'il ne s'agit pas d'un rendu initial
   * Le composant passe par une autre série d’étapes lorsque son parent refait son rendu
   * C’est l’endroit idéal pour vérifier si vos props vont changer par exemple
   * @param { any } prevProps
   * @param { any } prevState
   * @infos "https://reactjs.org"
   */
  public componentDidUpdate(prevProps: any, prevState: any) {
    {
      /** Comparaison */
    }
    if (prevState.radio !== this.state.radio) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ radio: this.state.radio }));
    } else if (prevState.seaRadio !== this.state.seaRadio) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState((state: any): any => ({ seaRadio: this.state.seaRadio }));
    }
  }
  /**
   * MAJ des inputs
   * @public
   * @method onChange
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onChange = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ displayaction: false }));

    if (
      Lodash.isNumber(Number(event.target.value)) &&
      Number(event.target.value) >= 0
    ) {
      {
        /** Empêcher la mutation du state */
      }
      this.setState({
        [event.target.name]: Number(event.target.value),
        extractionVideoBoolean: false,
      });

      {
        /** Empêcher la mutation du state */
      }
    } else {
      this.setState({ isNaN: true });
    }
  };
  /**
   * MAJ des inputs de type bouton
   * @public
   * @method onChangeDisplaySea
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onChangeDisplaySea = (param: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name seaRadio
     * @type boolean[]
     */
    const seaRadio: boolean[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.seaRadio.length); i++) {
      seaRadio.push(false);
    }
    seaRadio[param] = false; // true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ seaRadio }));
    this.setState((state: any): any => ({
      displayaction: false,
      extractionVideoBoolean: false,
    }));
  };
  /**
   * MAJ des inputs de type bouton
   * @public
   * @method onChangeDisplayHome
   * @param { number } param
   * @infos "https://reactjs.org"
   */
  public onChangeDisplayHome = (param: number) => (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    /**
     * @constant
     * @name radio
     * @type boolean[]
     */
    const radio: any[] = [];
    {
      /** boucle */
    }
    for (let i = 0; i < Math.ceil(this.state.displayArray.length); i++) {
      radio.push(false);
    }

    radio[param] = true;
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ radio }));
    this.setState((state: any): any => ({
      displayaction: false,
      extractionVideoBoolean: false,
    }));
  };
  /**
   * Manipulation des data vers le server
   * @public
   * @method onSubmitSea
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmitSea = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({ btnloading: false }));

    if (this.state.isNaN === false) {
      this.setState((state: any): any => ({
        displayaction: true,
        extractionVideoBoolean: false,
      }));
      {
        /** Empêcher la mutation du state */
      }
    } else {
      this.setState((state: any): any => ({ isNaN: true }));
    }
  };
  /**
   * Manipulation des data vers le server
   * @public
   * @method onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmitEVideo = (event: any): void => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.preventDefault();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      btnloading: true,
      displayaction: false,
    }));

    if (this.state.isNaN === false) {
      if (!Lodash.isUndefined(this.state.rulesVideoObject[2])) {
        if (this.state.rulesVideoObject[2].value <= 300) {
          this.props
            .DisplayParamVideoActionCreator(this.state.rulesVideoObject)
            .then(() =>
              this.setState((state: any): any => ({
                btnloading: false,
                displayaction: true,
              }))
            );
        } else {
          this.setState((state: any): any => ({
            btnloading: false,
            extractionVideoBoolean: true,
          }));
        }
      }

      {
        /** Empêcher la mutation du state */
      }
    } else {
      this.setState((state: any): any => ({ isNaN: true }));
    }
  };
  /**
   * Manipulation des data vers le server
   * @public
   * @method onSubmit
   * @param { any } event
   * @infos "https://reactjs.org"
   */
  public onSubmit = (event: any) => {
    {
      /** Empêcher le rechargement de la page */
    }
    event.persist();
    {
      /** Empêcher la mutation du state */
    }
    this.setState((state: any): any => ({
      btnloading: true,
      displayaction: false,
    }));

    if (this.state.isNaN === false) {
      /**
       * Afin d'améliorer la performance de l'interface on utilise des actions
       * espacé dans le temps
       */
      this.debounceSubmit(event);

      {
        /** Empêcher la mutation du state */
      }
    } else {
      this.setState((state: any): any => ({ isNaN: true }));
    }
  };

  /**
   * Cycle de vie d'un composant react
   * @method
   * @name render
   * @description : il est appelée. Pour le rendu ,
   * Ici le DOM virtuel fusionne avec le DOM réel
   * @param {  }
   * @infos "https://reactjs.org"
   */
  public render() {
    return (
      <Component
        onSubmitSea={this.onSubmitSea}
        onSubmitEVideo={this.onSubmitEVideo}
        onChangeDisplaySea={this.onChangeDisplaySea}
        onSubmit={this.onSubmit}
        onChangeDisplayHome={this.onChangeDisplayHome}
        onChange={this.onChange}
        onChangeVideoRules={this.onChangeVideoRules}
        {...this.props}
        {...this.state}
      />
    );
  }
}
/**
 * @function
 * @name mapStateToProps
 * @description : mapStateToProps prend
 * un composant en entrée et retourne le même composant avec de props
 * @param { any } state
 * @infos "https://react-redux.js.org/using-react-redux/connect-mapstate"
 */
export function mapStateToProps(state: any) {
  {
    /** nouveaux props */
  }
  return {
    data: state.ParametersDisplayLoaded.data,
    error: state.ParametersDisplayLoaded.error,
    videoInfosData: state.DisplayParamVideoLoaded.data,
  };
}
{
  /** exporter le HOC : connect */
}
export default connect(mapStateToProps, {
  DisplayParamVideoLoadedActionCreator,
  DisplayParamVideoActionCreator,
  ParametersDisplayLoadedActionCreator,
  ParametersDisplayUpdatedActionCreator,
})(Container);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/display/home/container.tsx